import './accommodations_posts.css';
